import { gql } from 'apollo-angular';

export var update_project_disclosure = gql`
  mutation updateProjectDisclosure($id: ID!, $disclosures: String!) {
    disclosure: updateProjectDisclosure(id: $id, disclosures: $disclosures) {
      id
      disclosures
    }
  }
`;
